// extracted by mini-css-extract-plugin
export default {"noTemplates":"styles_noTemplates__w21-5","noTemplatesIcon":"styles_noTemplatesIcon__UF+CM"};